import { render, staticRenderFns } from "./share-appointment-record.vue?vue&type=template&id=05532ac3&scoped=true"
import script from "./share-appointment-record.vue?vue&type=script&lang=js"
export * from "./share-appointment-record.vue?vue&type=script&lang=js"
import style0 from "./share-appointment-record.vue?vue&type=style&index=0&id=05532ac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05532ac3",
  null
  
)

export default component.exports